import layoutStyles from '../../../styles/pages/index.module.scss';
import CustomHead from '../../components/CustomHead';
import Footer from '../../components/Footer/Footer';
import Header from '../../components/Header/Header';
import Navigation from '../../components/Navigation/Navigation';
import OrderDeliveryForm from '../../components/OrderDeliveryForm/OrderDeliveryForm';
import { getOrFetchFooterLinks } from '../../utils/footerLinks';
import { getOrFetchNavigationLinks } from '../../utils/navigationLinks';
import pageStyles from '../order-delivery.module.scss';

export default function OrderDelivery({ footerLinks, navigation }) {
  return (
    <div className={pageStyles.pageContainer}>
      <CustomHead title="Στοιχεία Παραγγελίας" />
      <div className={layoutStyles.headerContainer}>
        <Header navigation={navigation} isDisabled />
        <Navigation navigation={navigation} />
      </div>
      <div className={pageStyles.layout}>
        <OrderDeliveryForm />
      </div>
      <div className={pageStyles.footerContainer}>
        <Footer footerLinks={footerLinks} />
      </div>
    </div>
  );
}

export async function getStaticProps() {
  const [{ data: navigation }, footerLinks] = await Promise.all([getOrFetchNavigationLinks(), getOrFetchFooterLinks()]);

  return {
    props: { navigation, footerLinks },
  };
}
